import axios from 'axios';
import * as queryString from "query-string";
import {API_URL} from "../config/constant";

export const authService = {
    async getToken(policeStationId) {
        return axios({
            method: 'POST',
            url: `${API_URL}/auth/token`,
            data: queryString.stringify({t: new Date().getTime(), police_station_id: policeStationId})
        })
            .then(function (response) {
                return response.data
            }).catch(() => {
                return false
            });
    },


    async signIn(username, password) {
        return axios({
            method: 'POST',
            url: `${API_URL}/auth/login`,
            data: queryString.stringify({username: username, password: password})
        })
            .then(function (response) {
                return response.data
            }).catch(() => {
                return false
            });
    },


    async getUserInfo() {
        return axios({
            method: 'GET',
            url: `${API_URL}/auth/user_info`
        })
            .then(function (response) {
                return response.data
            }).catch(() => {
                return false
            });
    },


    async signOut() {
        return localStorage.removeItem('token')
    }
};
